import CTable from "components/widget/CTable/CTable"
import { useEffect, useState } from "react"
import { LayoutStore } from "store/layout-store"
import { DetailTransactionsProps } from "types/layout-types"
import { methodChangeTableCol } from "utils/layout-utils"
import moment from "jalali-moment";

export const DashboardTable = ({ trades, title }: DetailTransactionsProps) => {
    const { currentUserFields } = LayoutStore()
    const [list, setList] = useState<any>([])
    const [col, setCol] = useState<any>([
        {
            title: "ID ",
            isActive: true,
            render: (i: any) => (<span className="">{i?.id}</span>)
        },
        {
            title: "نماد ",
            en_title: 'order_Symbol',
            isActive: true,
            render: (i: any) => (<span className="">{i?.order_Symbol}</span>)
        },
        {
            title: "نوع معامله",
            en_title: 'order_type',
            isActive: true,
            render: (i: any) => (<span className="pr-3">{i?.order_type == 'buy' ? 'BUY' : 'SELL'}</span>)
        },
        {
            title: " برآیند ",
            en_title: 'order_profit',
            isActive: true,
            render: (i: any) => (
                <>
                    {i?.order_profit > 0 && <span className={` font-bold text-green-500`}>مثبت</span>}
                    {i?.order_profit == 0 && <span className={` font-bold text-white`}>———</span>}
                    {i?.order_profit < 0 && <span className={` font-bold text-red-500`}>منفی</span>}
                </>
            )
        },
        {
            title: "حجم (لات)",
            en_title: 'order_lots',
            isActive: true,
            render: (i: any) => (<span className="">{i?.order_lots}</span>)
        },
        {
            title: " پیپ ",
            en_title: 'pip',
            isActive: true,
            render: (i: any) => (<span className="">{(i?.order_open_price - i?.order_close_price)?.toFixed(4)}</span>)
        },
        {
            title: " سود/ ضرر ",
            en_title: 'order_profit',
            isActive: true,
            render: (i: any) => (
                <>
                    {i?.order_profit > 0 && <span className={` font-bold text-green-500`}>$ {i?.order_profit}</span>}
                    {i?.order_profit == 0 && <span className={` font-bold text-white`}>$ {i?.order_profit}</span>}
                    {i?.order_profit < 0 && <span className={` font-bold text-red-500`}>$ {i?.order_profit}</span>}
                </>
            )
        },
        {
            title: " زمان باز شدن پوزیشن",
            en_title: 'order_open_time',
            isActive: true,
            render: (i: any) => (
                <>
                    <span className="mx-1">{moment(i.order_open_time).locale('fa').format("YYYY/M/D")}</span>
                    -
                    <span className="mx-1">{i?.order_open_time.slice(11, 16)}</span>
                </>
            )
        },
        {
            title: " زمان بسته شدن پوزیشن",
            en_title: 'order_close_time',
            isActive: true,
            render: (i: any) => (
                <>
                    <span className="mx-1">{moment(i.order_close_time).locale('fa').format("YYYY/M/D")}</span>
                    -
                    <span className="mx-1">{i?.order_close_time.slice(11, 16)}</span>
                </>
            )
        },
        {
            title: " Open Price",
            en_title: 'order_open_price',
            isActive: true,
            render: (i: any) => (<span className="">$ {i?.order_open_price}</span>)
        },
        {
            title: " Close Price",
            en_title: 'order_close_price',
            isActive: true,
            render: (i: any) => (<span className="">$ {i?.order_close_price}</span>)
        },
        {
            title: " زمان ",
            en_title: 'order_close_time',
            isActive: true,
            render: (i: any) => (<span className={`${i?.order_close_time.slice(11, 16) == i?.order_open_time.slice(11, 16) && 'text-red-500'}`}>{i?.order_close_time.slice(11, 16)}</span>)
        },
    ])

    // بررسی میکنه چه فیلدهایی در جدول اجازه نمایش دارند
    useEffect(() => {
        methodChangeTableCol(col, setCol, currentUserFields)
    }, [currentUserFields])


    //  فقط برای اینکه خط اول جدول نمایش داده نشه
    useEffect(() => {
        if (trades) {
            let data = trades.filter((item: any, index: number) => {
                return index != 0;
            })
            setList(data.reverse())
        }
    }, [trades])

    return (
        <>
            <div className="flex flex-col w-full text-white ">
                {title &&
                    <h3 className="mb-1 text-white">{title}</h3>
                }
                <CTable data={list} columns={col} />
            </div>
        </>
    )
}